import { useMutation, useQueryClient } from '@tanstack/react-query';

import { callRemoveWallet, initializeWalletsAsync } from '@app/store/zustand';

import { USER_WALLETS_CACHE } from './useWalletsQueryById';

interface RemoveParams {
    accountAddress: string;
}

export function useRemoveWalletMutation() {
    const queryClient = useQueryClient();

    async function handleInvalidateWalletCache() {
        await initializeWalletsAsync();
        void queryClient.invalidateQueries({
            predicate: ({ queryKey }) => queryKey[0] === USER_WALLETS_CACHE,
        });
    }

    return useMutation((params: RemoveParams) => callRemoveWallet({ variables: params }), {
        onSuccess: handleInvalidateWalletCache,
    });
}
